import { render, staticRenderFns } from "./WorkIconCall.vue?vue&type=template&id=fc5607bc"
import script from "./WorkIconCall.vue?vue&type=script&lang=js"
export * from "./WorkIconCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports